import { useMutation, useQuery, useQueryClient, type UseQueryOptions } from "@tanstack/react-query";
import { api } from "./api";
import { useWsKey } from "./session";

/** GET no escopo do workspace ativo; a chave inclui o workspace e os parâmetros. */
export function useWsQuery<T = any>(path: string | null, opts: Partial<UseQueryOptions<T>> & { keyExtra?: unknown[] } = {}) {
  const key = useWsKey(path, ...(opts.keyExtra ?? []));
  return useQuery<T>({ queryKey: key, queryFn: ({ signal }) => api.get<T>(path!, signal), enabled: !!path && (opts.enabled ?? true), ...opts } as UseQueryOptions<T>);
}

/** Mutação que invalida as queries do workspace após sucesso. */
export function useWsMutation<TVars = any, TRes = any>(fn: (v: TVars) => Promise<TRes>, opts: { invalidate?: boolean; onSuccess?: (r: TRes, v: TVars) => void } = {}) {
  const qc = useQueryClient();
  return useMutation<TRes, Error, TVars>({
    mutationFn: fn,
    onSuccess: async (r, v) => {
      if (opts.invalidate !== false) await qc.invalidateQueries({ queryKey: ["ws"] });
      opts.onSuccess?.(r, v);
    },
  });
}
